import { Link } from "react-router-dom";

const BeamIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="3" />
        <rect x="2" y="17" width="20" height="3" />
        <line x1="12" y1="7" x2="12" y2="17" strokeWidth="3" />
    </svg>
);

const StairsIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 20 8 20 8 15 13 15 13 10 18 10 18 5 21 5" />
        <line x1="3" y1="20" x2="3" y2="22" />
    </svg>
);

const NetworkIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="2.5" />
        <circle cx="5" cy="5" r="2" />
        <circle cx="19" cy="5" r="2" />
        <circle cx="5" cy="19" r="2" />
        <circle cx="19" cy="19" r="2" />
        <line x1="7" y1="6.5" x2="10.5" y2="10.5" />
        <line x1="17" y1="6.5" x2="13.5" y2="10.5" />
        <line x1="7" y1="17.5" x2="10.5" y2="13.5" />
        <line x1="17" y1="17.5" x2="13.5" y2="13.5" />
    </svg>
);

const SERVICES = [
    {
        title: 'Structural Steel Detailing',
        description: 'Complete shop drawings, erection plans, and parts details produced from accurate SDS2 3D models — ready for fabrication and field.',
        bullets: ['Shop Drawings', 'Erection & Placement Plans', 'Field Bolt Lists', 'CNC / NC1 / DSTV / DXF outputs'],
        icon: BeamIcon,
    },
    {
        title: 'Miscellaneous Metals',
        description: 'Stairs, railings, ladders, platforms, and complex misc. steel — detailed to the same accuracy standard as your main framing.',
        bullets: ['Stairs & Railings', 'Platforms & Ladders', 'Custom Connections', 'Architectural Metals'],
        icon: StairsIcon,
    },
    {
        title: 'BIM & Project Management',
        description: 'BIM coordination with your customer and design teams. Tekla PowerFab + KSS integration for end-to-end production visibility.',
        bullets: ['BIM Management', 'Design-Assist & Delegated Design', 'Tekla PowerFab Integration', 'Cross-Team Coordination'],
        icon: NetworkIcon,
    },
];

export const ServicesSection = () => (
    <section className="py-20 md:py-28 bg-steel-50">
        <div className="container-px mx-auto max-w-7xl">
            <div className="max-w-3xl mb-16">
                <p className="text-sm font-semibold text-navy-600 uppercase tracking-[0.2em] mb-4">What we do</p>
                <h2 className="text-display-lg font-display text-navy-900 mb-5">
                    Detailing that fits the way you fabricate.
                </h2>
                <p className="text-lg text-steel-600 leading-relaxed">
                    From complex structural framing to architectural misc. metals, we deliver drawings
                    and model outputs that flow directly into your shop's automated equipment and
                    production software.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {SERVICES.map((service) => {
                    const Icon = service.icon;
                    return (
                        <div
                            key={service.title}
                            className="group relative bg-white rounded-2xl p-8 shadow-card hover:shadow-card-hover transition-all duration-300 border border-steel-100 hover:border-navy-600/20 hover:-translate-y-1"
                        >
                            <div className="w-14 h-14 rounded-xl bg-navy-900 text-accent flex items-center justify-center mb-6 group-hover:bg-navy-700 transition-colors">
                                <Icon />
                            </div>
                            <h3 className="text-xl font-bold text-navy-900 mb-3 font-display">{service.title}</h3>
                            <p className="text-steel-600 mb-5 leading-relaxed">{service.description}</p>
                            <ul className="space-y-2 mb-6">
                                {service.bullets.map((b) => (
                                    <li key={b} className="flex items-start gap-2 text-sm text-steel-700">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2A5BA8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        {b}
                                    </li>
                                ))}
                            </ul>
                            <Link
                                to="/services"
                                className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy-700 no-underline group-hover:text-navy-600 group-hover:gap-2.5 transition-all"
                            >
                                Learn more
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                    <polyline points="12 5 19 12 12 19" />
                                </svg>
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);
